(function () {
  document.addEventListener('click', function (e) {
    // mobile nav
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-nav]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
    // quantity stepper
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      var wrap = (minus || plus).closest('.qty');
      var inp = wrap && wrap.querySelector('input');
      if (inp) {
        var v = parseInt(inp.value || '1', 10);
        inp.value = plus ? v + 1 : Math.max(1, v - 1);
      }
    }
  });

  // close mobile nav on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var nav = document.querySelector('[data-nav].is-open');
      if (nav) {
        nav.classList.remove('is-open');
        var t = document.querySelector('[data-nav-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    }
  });
})();
